import React, { useEffect, useState } from "react";
import AdminPurchaseEntryNew from "./AdminPurchaseEntryNew";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import GetApiService from "Components/Api/getapiService";
import { a161, a164, a165 } from "Components/Api/RootApiPath";
import { useQuery } from "@tanstack/react-query";
import { convertIntoFormData } from "utils/helpers";





const AdminEditPurchaseEntryNew = () => {
  const [editStatus, setEditStatus] = useState(true);
  const [defaultData, setDefaultData] = useState();
  const [responseData, setResponseData] = useState();
  const { id } = useParams();
  const allStates = useSelector((state) => state);
  const adminLoggedIn = allStates?.reducer1;
  const clientCode = adminLoggedIn.ClientCode;
  const apiService = new GetApiService(clientCode);

  const getPurchaseById = async ({ id, clientCode }) => {
    try {
      const purchaseEntry = await fetch(a161, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ id, clientCode }),
      });
      const purchaseItemsResponse = await fetch(a164, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ ClientCode:clientCode, RDPurchaseId:id }),
      });

  
      
      const data = await purchaseEntry.json()
      const purchaseItems = await purchaseItemsResponse.json()
      const res = convertIntoFormData(data,purchaseItems);
      console.log(res)
      setDefaultData(res);
    } catch (error) {
      throw new Error(`Failed to fetch dropdown list data: ${error.message}`);
    }
  };

  useEffect(() => {
    getPurchaseById({ id, clientCode });
  }, [id, clientCode]);




  return (
    <>
      {defaultData ? (
        <AdminPurchaseEntryNew
          editStatus={editStatus}
          defaultValues={defaultData}
        />
      ) : (
        ""
      )}
    </>
  );
};

export default AdminEditPurchaseEntryNew;
